import React from 'react';
import { useParams } from 'react-router-dom';
import { ActionType, StudentActionParams } from './studentAction.type';
import AddStudent from '../addStudent/AddStudent';

function StudentAction() {
  const { id, type } = useParams<StudentActionParams>();

  const actionMapping: { [key in ActionType]: JSX.Element } = {
    edit: <AddStudent mode="edit" id={id} />,
    view: <AddStudent mode="view" id={id} />
  };

  return type ? actionMapping[type] : <></>;
}

export default StudentAction;
